// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__25Vdc","buttons":"SendReceipts_buttons__8KFZS","email":"SendReceipts_email__2sLL1","bookApptTitle":"SendReceipts_bookApptTitle__jwVp5"};